import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function StatCard(props) {
  return /*#__PURE__*/_jsxs("div", {
    className: "rounded-2xl bg-[#F7F7F7] font-mono px-6 py-7",
    children: [/*#__PURE__*/_jsx("div", {
      className: "text-grey-400 text-4xl",
      children: props.value
    }), /*#__PURE__*/_jsx("div", {
      className: "font-bold text-md mt-6",
      children: props.title
    })]
  });
}